/** Aufrufe der Termine -- F1-51 bis F1-54. */

import type { components } from '../../api/schema';
import { request } from '../../lib/apiClient';

export type Appointment = components['schemas']['AppointmentRead'];
export type AppointmentCreate = components['schemas']['AppointmentCreate'];
export type AppointmentUpdate = components['schemas']['AppointmentUpdate'];

export interface AppointmentFilters {
  ticket_id?: string;
  /** Nur die Termine, an denen der Anmeldende teilnimmt. */
  mine?: boolean;
  since?: string;
  until?: string;
}

export function listAppointments(filters: AppointmentFilters): Promise<Appointment[]> {
  return request<Appointment[]>('/appointments', { query: { ...filters } });
}

export function createAppointment(payload: AppointmentCreate): Promise<Appointment> {
  return request<Appointment>('/appointments', { method: 'POST', body: payload });
}

export function updateAppointment(id: string, payload: AppointmentUpdate): Promise<Appointment> {
  return request<Appointment>(`/appointments/${id}`, { method: 'PATCH', body: payload });
}

export function deleteAppointment(id: string): Promise<undefined> {
  return request<undefined>(`/appointments/${id}`, { method: 'DELETE' });
}
